import React from 'react';
import { Input } from 'formik-antd';
import FormControl from '~/components/Form/FormControl';
import Button from '~/components/Button';
import i18next from 'i18next';
import { FaTrash } from 'react-icons/fa';
import { Flex } from 'antd';

export const financialExpenseItemsColumns = (errors, fluidPermissions) => {
  return [
    {
      title: i18next.t('fields:event.service.name'),
      dataIndex: 'name',
      key: 'name',
      width: '90%',
      render: (_, record, index) => (
        <FormControl
          field={`financial_expense_items.${index}.name`}
          error={errors?.financial_expense_items?.[index]?.name}
          required
          list
        >
          <Input name={`financial_expense_items.${index}.name`} disabled={!fluidPermissions()} />
        </FormControl>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (_, record, index) => (
        <Flex align="center" justify="center">
          <Button
            color="danger"
            title="Remover despesa"
            size="small"
            style={{ width: '30px' }}
            onClick={() => record.remove(index)}
            disabled={!fluidPermissions()}
            icon={<FaTrash />}
          />
        </Flex>
      ),
    },
  ];
};
